/**
 * Shared constants for the Contacts / People feature.
 * Lives in lib/utils so screens stay free of config data.
 */

export const CONTACTS_PAGE_SIZE = 250;

export const CONTACTS_DEFAULT_COLUMNS = [
  "Name",
  "Phone Number",
  "Email",
  "Occupation",
  "Id Number",
];

export const CONTACTS_OPTIONAL_COLUMNS = [
  "Gender",
  "Title",
  "Country",
  "City",
  "Date of Birth",
  "GPS Location",
];

export const CONTACTS_ALL_COLUMNS = [
  ...CONTACTS_DEFAULT_COLUMNS,
  ...CONTACTS_OPTIONAL_COLUMNS,
];
